// Amplify
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";

// Auth
import {
  hasValidMBSAmplifyConfig,
  mbsAmplifyConfig,
} from "Auth/MBS/mbsAuthConfig";
import { primaryAmplifyConfig } from "Auth/Primary/primaryAuthConfig";
import { mbsStorage } from "Auth/MBS/mbsStorage";
import { getAuthDomainForPath } from "Auth/authUtils";

// Constants
import { AUTH_DOMAINS } from "Constants/AuthConstants";

export const initialAuthDomain = getAuthDomainForPath(window.location.pathname);

export const bootstrapAuth = () => {
  const shouldBootstrapMBS =
    initialAuthDomain === AUTH_DOMAINS.MBS && hasValidMBSAmplifyConfig();

  Amplify.configure(
    shouldBootstrapMBS ? mbsAmplifyConfig : primaryAmplifyConfig
  );
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    shouldBootstrapMBS ? mbsStorage : sessionStorage
  );
};
